import { ProjectHeadVO } from '@project/model/vo/project.vo';

export class MultipleQuoteRequestData {
  projectName: string;
  projects: ProjectHeadVO[];

  constructor(projectName: string, projects: ProjectHeadVO[]) {
    this.projectName = projectName;
    this.projects = projects;
  }
}
